export enum SortOrder {
    Descending = 'Descending',
    Ascending = 'Ascending',
}
